export const CATALOG_REPORT_PANEL_ID = "catalog-report";
